import React from 'react';
import { Plus, AlertCircle, MapPin, FileDown, Calendar } from 'lucide-react';
export function QuickActions() {
  return <div className="mt-6 flex items-center space-x-3" data-id="element-594">
      <button className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-595">
        <Plus className="w-4 h-4" data-id="element-596" />
        <span className="text-sm font-medium" data-id="element-597">Nouvelle intervention</span>
      </button>
      <button className="flex items-center space-x-2 px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-598">
        <Calendar className="w-4 h-4" data-id="element-599" />
        <span className="text-sm font-medium" data-id="element-600">Voir planification</span>
      </button>
      <button className="flex items-center space-x-2 px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-601">
        <AlertCircle className="w-4 h-4" data-id="element-602" />
        <span className="text-sm font-medium" data-id="element-603">Créer alerte</span>
      </button>
      <button className="flex items-center space-x-2 px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-604">
        <MapPin className="w-4 h-4" data-id="element-605" />
        <span className="text-sm font-medium" data-id="element-606">Ajouter site</span>
      </button>
      <button className="flex items-center space-x-2 px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-607">
        <FileDown className="w-4 h-4" data-id="element-608" />
        <span className="text-sm font-medium" data-id="element-609">Exporter</span>
      </button>
    </div>;
}